export const TrackerObjectiveValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentStatusOptions = {
  ASSIGNED: 'assigned',
  REVISE: 'revise',
  SUBMITTED: 'submitted',
  COMPLETE: 'complete'
};

export const AssignmentTaskValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentTaskValueTypeValueRange = {
  [AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR]: [0, 1, 2, 3, 4],
  [AssignmentTaskValueTypes.RUBRIC_A_TO_F]: ['A', 'B', 'C', 'D', 'F'],
  [AssignmentTaskValueTypes.PERFORMANCE]: [
    'beginning',
    'approaching',
    'proficient',
    'excelling'
  ]
};

export const AssignmentDepthOptions = {
  TASK: 1,
  CRITERIA: 2
};

export const MuiAutocompleteChangeReasons = {
  // For reference: https://material-ui.com/api/autocomplete/
  CREATE_OPTION: 'create-option',
  SELECT_OPTION: 'select-option',
  REMOVE_OPTION: 'remove-option',
  BLUR: 'blur',
  CLEAR: 'clear'
};

export const Environments = {
  DEV: 'development',
  STAGING: 'staging',
  PROD: 'production',
  REVIEW: 'review'
};

export const ImgixDimensions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const WebcamWidths = {
  WEBCAM_MOBILE: 960,
  WEBCAM_DESKTOP: 128
};

export const MAX_ATTACHMENT_FILE_SIZE_IN_BYTES = 20 * 1000 * 1000; // 20MB

export const BLUR_THRESHOLD = 400;
// const MOBILE_BLUR_THRESHOLD = 250;

export const SUBMITTED_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'all_submitted',
  value: 'submitted',
  label: 'Submitted'
};

export const INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'not_complete',
  value: 'incomplete',
  label: 'Incomplete'
};

export const ALL_STATUS_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'all',
  value: 'all_statuses',
  label: 'All Statuses'
};

export const STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTIONS = [
  SUBMITTED_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION,
  INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION,
  ALL_STATUS_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION
];

export const STUDENT_PORTFOLIO_STANDARD_TABS = {
  MATH: 'MATH',
  ELA: 'ELA',
  NO_STANDARDS: 'NO_STANDARDS'
};

export const STANDARD_MSA = {
  MAJOR: 'm',
  SUPPORTING: 's',
  ADDITIONAL: 'a'
};

export const MSA_LABEL_MAPPING = {
  m: 'Major',
  s: 'Supporting',
  a: 'Additional'
};

export const LIVE_CLASSROOM_TABS = {
  COMMON_ISSUES: 'Common Issues - Action Needed'
};

export const EMBER_STATUSES = {
  IN_PROGRESS: 'in_progress',
  NOT_AVAILABLE: 'not__available',
  NOT_STARTED: 'not_started'
};

export const VIDEO_INPUT = 'videoinput';
export const FRONT_CAMERA = 'front';

export const LIVE_CLASSROOM_TEACHERS_DOMAIN = [
  'kippsocal.org',
  'dpsnc.net',
  'leadpublicschools.org',
  'pgcps.org',
  'aacps.org',
  'cfschools.net',
  'becomingschools.org',
  'globalprepindy.org'
];

export const MOUSE_DOWN_EVENT = 'mousedown';
export const MOUSE_UP_EVENT = 'mouseup';
export const MOUSE_MOVE_EVENT = 'mousemove';
export const CLICK_EVENT = 'click';
export const KEY_DOWN_EVENT = 'keydown';
